import React, {useState, useRef, useContext} from 'react'
import {Box, Button, Grid, TextField, MenuItem, Radio, CircularProgress} from '@material-ui/core/'
import BarcodeToolTip from '../BarcodeToolTip'
import {editOutputTooltip} from '../BarcodeToolTip/toolTipInfo'
import {createBarcodeSetting} from '../../graphql/barcode/mutations/barcodeSettingMutation'
import {Mutation} from 'react-apollo'
import {libraryPageQuery} from '../../graphql/barcode/queries/libraryPageQuery'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeLibraryEditTemplate.styles'
import {ToastMessageContext} from '../../context/ToastMessage'
import {barcodeSheetQuery} from '../../graphql/barcode/queries/barcodeSheetQuery'
import {Query} from 'react-apollo'
import BarcodeLoadingScreen from '../BarcodeLoadingScreen'

export default function BarcodeLibraryEditTemplate(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const accessToken = JSON.parse(window.localStorage.getItem('token'))
  const userId = parseInt(window.localStorage.getItem('user_id'))
  const [formValues, setFormValues] = useState({
    name: props.record.name,
    labelTemplate: props.record.barcodeLabelId,
    output: props.record.output,
    digits: props.record.digits,
    startNumber: props.record.startNumber,
    prefix: props.record.prefix,
    group: props.record.entityId,
    field: props.record.fieldId,
  })
  const [fieldShow, setFieldShow] = useState(
    props.record.entityId ? props.record.fields[props.record.entityId] : []
  )
  const [nameError, setNameError] = useState(false)
  const [digitsError, setDigitsError] = useState(false)
  const [updateTemplate, setUpdateTemplate] = useState(false)
  const refBtnSave = useRef(null)
  const toast = useContext(ToastMessageContext)

  const handleChange = textField => event => {
    if (textField === 'group') {
      setFieldShow(props.record.fields[event.target.value])
      setFormValues({
        ...formValues,
        [textField]: event.target.value,
        field: props.record.fields[event.target.value][0].id,
      })
    } else {
      setFormValues({
        ...formValues,
        [textField]: event.target.value,
      })
    }
  }

  function handleSave(barcodeSetting, event) {
    if (checkValidity()) {
      barcodeSetting({
        variables: {
          id: props.record.id,
          accountId: props.record.accountId,
          barcodeLabelId: parseInt(formValues.labelTemplate),
          output: formValues.output,
          digits: parseInt(formValues.digits),
          prefix: formValues.prefix,
          startNumber: parseFloat(formValues.startNumber),
          name: formValues.name,
          dataSource: props.showTable === 'automated' ? 'automated' : 'from_objects',
          fieldId: props.showTable === 'automated' ? null : parseInt(formValues.field),
          entityId: props.showTable === 'automated' ? null : parseInt(formValues.group),
        },
      })
      props.disableButton(true)
      setUpdateTemplate(true)
    }
  }

  function mutationLoad(data) {
    props.disableButton(false)
    setUpdateTemplate(false)

    if (data['createBarcodeSetting']['errors'].length > 0) {
      setNameError(true)
      toast.popMessage(
        t('barcode.wizard.create-barcode-sheet.error-name-taken'),
        'error',
        refBtnSave.current
      )
    } else {
      toast.popMessage(
        t('barcode.library.edit-barcode-template.success-edit'),
        'success',
        refBtnSave.current
      )
    }
  }

  function checkValidity() {
    let errorMessage = ''
    const digit = parseInt(formValues.digits)
    setNameError(false)
    setDigitsError(false)
    if (formValues.name === '') {
      errorMessage = t('barcode.library.edit-barcode-template.name-blank')
      setNameError(true)
    } else if (props.showTable === 'automated' && (digit === 0 || digit > 50)) {
      errorMessage = t('barcode.library.edit-barcode-template.digits-least')
      setDigitsError(true)
    } else if (
      props.showTable === 'automated' &&
      formValues.startNumber <= parseInt(props.record.lastPrinted)
    ) {
      errorMessage = t('barcode.library.edit-barcode-template.update-start-number')
      setDigitsError(true)
    } else if (props.showTable === 'automated' && formValues.startNumber.length > digit) {
      errorMessage = t('barcode.library.edit-barcode-template.digits-start')
      setDigitsError(true)
    }

    if (errorMessage === '') {
      return true
    } else {
      toast.popMessage(errorMessage, 'error', refBtnSave)
      return false
    }
  }

  function labelData(data) {
    if (!data.barcodeSheet) {
      return []
    } else {
      return data.barcodeSheet.find(obj => obj.id === props.record.sheet.id).labels
    }
  }

  return (
    <div>
      <Grid container spacing={3}>
        <Grid container item xs={12} justify="flex-start">
          <TextField
            id="name"
            label={t('barcode.library.edit-barcode-template.name')}
            value={formValues.name}
            fullWidth
            variant="outlined"
            onChange={handleChange('name')}
            error={nameError}
            disabled={updateTemplate}
          />
        </Grid>

        <Grid container item xs={12} justify="flex-start">
          <TextField
            id="data-source"
            label={t('barcode.library.edit-barcode-template.data-source')}
            disabled
            value={
              props.record.dataSource === 'automated'
                ? 'Automatically Generated'
                : 'Generated From Field Value'
            }
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid container item xs={12} justify="flex-start">
          <Query
            query={barcodeSheetQuery}
            variables={{accountId: props.record.accountId}}
            fetchPolicy="network-only"
          >
            {({loading, error, data}) => {
              if (loading)
                return (
                  <div>
                    <BarcodeLoadingScreen size={50} />
                  </div>
                )
              if (error)
                return (
                  <div>
                    {props.history.push({
                      pathname: 'pageNotFound',
                    })}
                  </div>
                )

              return (
                <TextField
                  id="label-records"
                  select
                  label={t('barcode.library.edit-barcode-template.label-template')}
                  value={formValues.labelTemplate}
                  fullWidth={true}
                  onChange={handleChange('labelTemplate')}
                  disabled={updateTemplate}
                  SelectProps={{
                    MenuProps: {
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                    },
                  }}
                  variant="outlined"
                >
                  {labelData(data).map(label => (
                    <MenuItem key={label.id} value={label.id}>
                      {label.name}
                    </MenuItem>
                  ))}
                </TextField>
              )
            }}
          </Query>
        </Grid>

        <Grid container item xs={12} justify="flex-start">
          <Box fontSize={12} fontWeight={200} marginBottom={-5} marginLeft={2}>
            {t('barcode.library.edit-barcode-template.output')}
          </Box>
          <Box marginBottom={-5} marginTop={-1} marginLeft={-2}>
            <BarcodeToolTip tooltipInfo={editOutputTooltip} />
          </Box>
        </Grid>

        <Grid container item xs={12} justify="flex-start">
          <Grid item xs={5} className={classes.cardStyle}>
            <Radio
              checked={formValues.output === 'pdf'}
              onChange={handleChange('output')}
              color="primary"
              disabled={updateTemplate}
              value="pdf"
            />
            {t('barcode.library.edit-barcode-template.pdf')}
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={5} className={classes.cardStyle}>
            <Radio
              checked={formValues.output === 'png'}
              onChange={handleChange('output')}
              color="primary"
              value="png"
              disabled={updateTemplate}
            />
            {t('barcode.library.edit-barcode-template.png')}
          </Grid>
        </Grid>

        {props.showTable === 'automated' ? (
          <Grid container item xs={12} justify="flex-start">
            <Grid item xs={5}>
              <TextField
                id="digits"
                label={t('barcode.library.edit-barcode-template.digits')}
                value={formValues.digits}
                fullWidth
                type="number"
                variant="outlined"
                onChange={handleChange('digits')}
                error={digitsError}
                disabled={updateTemplate}
              />
            </Grid>
            <Grid item xs={2} />
            <Grid item xs={5}>
              <TextField
                id="starting-number"
                label={t('barcode.library.edit-barcode-template.start-number')}
                value={formValues.startNumber}
                fullWidth
                type="number"
                variant="outlined"
                onChange={handleChange('startNumber')}
                error={digitsError}
                disabled={updateTemplate}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container item xs={12} justify="flex-start">
            <Grid item xs={5}>
              <TextField
                id="Fields"
                select
                label={t('barcode.library.edit-barcode-template.group')}
                value={formValues.group}
                fullWidth={true}
                onChange={handleChange('group')}
                SelectProps={{
                  MenuProps: {
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                  },
                }}
                disabled={updateTemplate}
                variant="outlined"
              >
                {props.record.entities.map(output => (
                  <MenuItem key={output.id} value={output.id}>
                    {output.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={2} />

            <Grid item xs={5}>
              <TextField
                id="fields"
                select
                label={t('barcode.library.edit-barcode-template.field')}
                value={formValues.field}
                fullWidth={true}
                onChange={handleChange('field')}
                SelectProps={{
                  MenuProps: {
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                  },
                }}
                disabled={updateTemplate}
                variant="outlined"
              >
                {fieldShow.map(output => (
                  <MenuItem key={output.id} value={output.id}>
                    {output.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        )}

        <Grid container item xs={12} justify="flex-start" hidden={props.showTable === 'fieldValue'}>
          <TextField
            id="prefix"
            label={t('barcode.library.edit-barcode-template.prefix')}
            value={formValues.prefix}
            fullWidth
            variant="outlined"
            onChange={handleChange('prefix')}
            disabled={updateTemplate}
          />
        </Grid>

        <Box marginTop={15} />
        <Grid container item xs={12} justify="flex-start">
          <Mutation
            mutation={createBarcodeSetting}
            refetchQueries={() => [
              {
                query: libraryPageQuery,
                variables: {
                  accountId: parseInt(props.record.accountId),
                  token: accessToken,
                  userId: userId,
                  filter: '',
                },
              },
            ]}
            awaitRefetchQueries
            onCompleted={data => mutationLoad(data)}
          >
            {(createBarcodeSetting, {data}) => (
              <Button
                ref={refBtnSave}
                value="save-template"
                variant="contained"
                color="primary"
                fullWidth={true}
                onClick={e => handleSave(createBarcodeSetting, e)}
                disabled={updateTemplate}
                style={{textTransform: 'none'}}
              >
                {updateTemplate ? (
                  <div>
                    {t('barcode.library.edit-barcode-template.updating')}
                    <CircularProgress size={20} color="secondary" />
                  </div>
                ) : (
                  t('barcode.library.edit-barcode-template.update-template')
                )}
              </Button>
            )}
          </Mutation>
        </Grid>
      </Grid>
    </div>
  )
}
